export default function (url: string) {
    return 'url(' + url + ')'
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Utils/CssUrl.ts